import React from "react";
import { ChatBubbleLeftRightIcon, ClipboardIcon, CheckIcon } from "@heroicons/react/24/outline";
import { formatDate } from "../../../lib/date_utils";

interface TraceHeaderProps {
  traceId: string;
  createdAt: string;
  copied: boolean;
  onCopy: () => void;
}

export function TraceHeader({ traceId, createdAt, copied, onCopy }: TraceHeaderProps) {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
            <ChatBubbleLeftRightIcon className="w-5 h-5 text-muted-foreground" />
            Trace / <code className="font-mono text-primary">{traceId.slice(0, 12)}</code>
          </h2>
          <p className="text-sm text-muted-foreground mt-1">{formatDate(createdAt)}</p>
        </div>
        <button
          onClick={onCopy}
          title="Copy full trace ID"
          className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground shrink-0"
        >
          {copied ? (
            <CheckIcon className="w-3.5 h-3.5 text-success" />
          ) : (
            <ClipboardIcon className="w-3.5 h-3.5" />
          )}
          {copied ? "Copied" : "Copy ID"}
        </button>
      </div>
    </div>
  );
}
